/** The Tools panel's Shift section (web): the interpreter's breaks in a call. */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from '../../base/styles/functions.web';
import Button from '../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../base/ui/constants.any';
import useShiftBreaks from './useShiftBreaks';
const useStyles = makeStyles()(theme => ({
    line: { ...withPixelLineHeight(theme.typography.bodyShortRegular), margin: '0 0 12px', overflowWrap: 'anywhere' },
    controls: { display: 'flex', flexDirection: 'column', gap: theme.spacing(2) },
    breakAction: { borderWidth: 2, borderColor: theme.palette.focus01 },
    button: { transition: 'none', border: `1px solid ${theme.palette.ui04}`, minHeight: 48, width: '100%', whiteSpace: 'normal', textAlign: 'start',
        '&:focus-visible': { outline: `2px solid ${theme.palette.focus01}`, outlineOffset: 2 } },
    note: { ...withPixelLineHeight(theme.typography.bodyShortRegular), marginTop: theme.spacing(2), overflowWrap: 'anywhere' }
}));
/**
 * Start or end a break. Breaks load when the Tools panel opens, and an
 * uncertain change is kept (and checked, never replayed) while the room is
 * up, open or minimized.
 *
 * @param {Object} props - The props.
 * @param {boolean} props.open - Whether the Tools panel is open.
 * @returns {ReactElement}
 */
export default function ShiftSection({ open }) {
    const { classes } = useStyles();
    const shift = useShiftBreaks(open);
    return React.createElement("div", { "aria-busy": shift.busy || shift.availability.pending },
        React.createElement("div", { "aria-live": 'polite', className: classes.line }, shift.status === 'loading' ? 'Loading break status…' : shift.status === 'failed' ? 'Couldn\'t load break status. Try again.' : shift.line.text),
        React.createElement("div", { className: classes.controls },
            React.createElement(Button, { className: `${classes.button} ${classes.breakAction}`, type: BUTTON_TYPES.TERTIARY, disabled: shift.busy || shift.availability.pending || !shift.unconfirmed && shift.status !== 'ready', label: shift.busy ? shift.unconfirmed ? 'Checking break…' : shift.line.active ? 'Ending break…' : 'Starting break…' : shift.unconfirmed ? 'Check break status' : shift.line.active ? 'End break' : 'Start break', onClick: shift.unconfirmed ? shift.checkBreak : shift.toggleBreak }),
            shift.status !== 'ready' && React.createElement(Button, { className: classes.button, disabled: shift.busy || shift.unconfirmed, label: 'Refresh break status', onClick: shift.loadBreaks, type: BUTTON_TYPES.TERTIARY }),
            shift.availability.failed && React.createElement(Button, { className: classes.button, disabled: shift.busy || shift.unconfirmed, label: 'Retry status', onClick: shift.retryAvailability, type: BUTTON_TYPES.TERTIARY })),
        React.createElement("div", { "aria-live": 'polite', className: classes.note },
            shift.note,
            " ",
            shift.availability.text));
}
